// Mock data for Northwest Title Alliance rebrand

export const navLinks = [
  { label: 'Products', href: '#products' },
  { label: 'About', href: '#about' },
  { label: 'Roadmap', href: '#roadmap' },
  { label: 'Contact', href: '#contact' },
];

export const heroStats = [
  { value: '39', label: 'WA Counties' },
  { value: '3', label: 'Live AI Products' },
  { value: '30+', label: 'Years Industry XP' },
];

export const products = [
  {
    id: 'axiom',
    name: 'AXIOM',
    tagline: 'Virtual Underwriter',
    status: 'Live',
    description:
      'AI-powered underwriting guidance built on decades of title expertise. Ask complex underwriting questions and get authoritative, nuanced answers — instantly, in any state.',
    bullets: [
      'On-demand underwriting answers',
      'Editions for underwriters, lenders & more',
      'Any state. No waiting. No guessing.',
    ],
    href: 'https://underwriter.nwta.app/',
    accent: 'navy',
  },
  {
    id: 'art',
    name: 'ART',
    tagline: 'AI Rendered Title',
    status: 'Live',
    description:
      'An OIC-compliant, AI-powered title plant back to State Patent — fundamentally changing how title searches are performed in Washington State. Fast, accurate, and built for the modern title professional.',
    bullets: [
      'OIC-compliant title plant',
      'Back to State Patent',
      'Purpose-built for WA',
    ],
    href: 'https://art.titlecat.com/',
    accent: 'slate',
  },
  {
    id: 'truenorth',
    name: 'TrueNorth',
    tagline: 'Survey Intelligence',
    status: 'Live',
    description:
      'ALTA/NSPS survey underwriting intelligence. Drop in a title commitment and get automated closure checks, plottability analysis, and cited curative guidance — nationwide.',
    bullets: [
      'Automated metes-and-bounds closure checks',
      'Schedule B-II plottability vs ALTA Table A',
      'Works in all 50 states',
    ],
    href: 'https://truenorth.nwta.app/',
    accent: 'green',
  },
];

export const aboutStats = [
  { value: '3', label: 'AI Products', sub: 'Live and serving title professionals today' },
  { value: '30+', label: 'Years Experience', sub: 'Building & operating WA title companies' },
  { value: 'OIC', label: 'Compliant', sub: 'ART built to Washington State regulatory standards' },
];

export const pricingPillars = [
  {
    title: 'One Low Monthly Lease',
    body: 'A single, straightforward monthly lease gets you access to ART.',
  },
  {
    title: 'Pay at Successful Close',
    body: "Beyond the monthly lease, you only pay when a transaction closes. If the deal doesn't close, neither do we. Our success is tied directly to yours.",
  },
  {
    title: 'Every County, Forever',
    body: "As new counties go live, they're yours if they fall within your subscription plan. Your coverage grows with ART, with a simple points-based subscription.",
  },
];

export const roadmap = [
  {
    label: 'Live Now',
    tone: 'live',
    counties: ['Jefferson County', 'Mason County', 'Kitsap County', 'Grays Harbor County', 'Pierce County', 'Thurston County', 'Clallam County'],
  },
  {
    label: 'Coming 2026',
    tone: 'soon',
    counties: [
      'Clark County',
      'Yakima County',
      'Island County',
      'Lewis County',
      'Chelan County',
      'Pacific County',
    ],
  },
  {
    label: 'Coming 2027',
    tone: 'later',
    counties: [
      'King County',
      'Snohomish County',
      'Grant County',
      'Kittitas County',
      'San Juan County',
    ],
  },
  {
    label: 'On Roadmap',
    tone: 'roadmap',
    counties: [
      'Spokane County',
      'Whatcom County',
      'Benton County',
      'Skagit County',
      'Cowlitz County',
      'Franklin County',
      'Walla Walla County',
      'Stevens County',
      'Whitman County',
      'Douglas County',
      'Okanogan County',
      'Klickitat County',
      'Asotin County',
      'Adams County',
      'Pend Oreille County',
      'Skamania County',
      'Lincoln County',
      'Ferry County',
      'Wahkiakum County',
      'Columbia County',
      'Garfield County',
    ],
  },
];

